import Vue from 'vue'

import Calendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'

Vue.use(Calendar, {
  firstDayOfWeek: 1,
  titlePosition: 'left',
})
